import axios from './auth-v2-axios'
import { AuthCredential } from '@/types/credentials'

export function getCredential(credentialId: string) {
  return axios.get<AuthCredential>(
    `/v2/dr-chrono/org_credential_secrets/${credentialId}?redirect_path=/credential-authenticated`,
  )
}
